module.exports = __webpack_public_path__ + "static/media/petq.25c79c24.png";